var _Object$keys = require("../core-js/object/keys");

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = _Object$keys(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/helpers/objectWithoutPropertiesLoose.js
// module id = 16
// module chunks = 0